/**
 * 知识类型颜色映射
 * 用于提示词高亮和知识列表背景色，保持视觉一致性
 */
export const KNOWLEDGE_COLORS = {
  prompt: '#E3F2FD',      // 提示词 - 浅蓝色
  dataflow: '#E8F5E9',    // 数据流 - 浅绿色
  pin_info: '#FFF9C4',    // 针脚信息 - 浅黄色
  case: '#F3E5F5',        // 典型案例 - 浅紫色
  principle: '#FFF3E0'    // 系统原理 - 浅橙色
};

/**
 * 占位符（额外字段）颜色映射
 * 用于历史数据额外字段的背景色，与知识颜色协调但有所区分
 * 只为需要跳转的复杂字段定义颜色，简单元数据字段不需要高亮
 * 支持驼峰命名和下划线命名两种格式
 */
export const PLACEHOLDER_COLORS = {
  // 驼峰命名（新格式）
  engineVersion: '#E1F5FE',           // 发动机版本 - 浅蓝
  dcuVersion: '#E1F5FE',              // DCU版本 - 浅蓝
  engineFaultCodes: '#FFEBEE',       // 发动机故障码 - 浅红
  dcuFaultCodes: '#FFEBEE',           // DCU故障码 - 浅红
  supportedDataStreams: '#F3E5F5',    // 支持的数据流 - 浅紫
  collectedDataStreams: '#FFFDE7',    // 采集的数据流 - 浅黄
  userFaultPhenomenon: '#FCE4EC',     // 故障现象 - 浅粉
  userAdditionalInfo: '#F1F8E9',      // 用户附加信息 - 浅绿
  workingConditions: '#E8F5E9',      // 工况定义 - 浅绿
  selectedStreams: '#F3E5F5',         // 选中的数据流 - 浅紫
  // 下划线命名（兼容旧格式）
  fault_code_list: '#FFEBEE',         // 故障码列表 - 浅红
  working_conditions: '#E8F5E9',       // 工况定义 - 浅绿
  selected_streams: '#F3E5F5',         // 选中的数据流 - 浅紫
  csv_content: '#FFFDE7',             // CSV数据内容 - 浅黄
  csv_data_stream: '#FFFDE7'           // CSV数据流 - 浅黄（别名）
};

export default KNOWLEDGE_COLORS;

